import './installation-title.scss';
import WizardInfo from '../wizard-info/wizard-info';

export default angular.module('installer.title', [WizardInfo.name]).
  directive('installationTitle', (wizardInfo, i18n) => {
    const defaultInstallationTitle = i18n(`${wizardInfo.productPresentationName} Installer`);

    return {
      restrict: 'E',
      template: '<div class="installation-title">{{getInstallationTitle()}}</div>',
      scope: {
        text: '@'
      },
      link(scope) {
        scope.getInstallationTitle = function getInstallationTitle() {
          return scope.text ? scope.text.replace('#installationTitle#', wizardInfo.productPresentationName) : defaultInstallationTitle;
        };
      }
    };
  });



// WEBPACK FOOTER //
// ./src/blocks/installation-title/installation-title.js